import {useMutation} from '@tanstack/react-query';
import {GetProfessionalParams} from 'domain/usecases';
import {getRefundProfessional} from '../../services/getRefundProfessional';
import {UseGetRefundProvidersMutationProps} from './types';

export const useRefundProvidersMutation = ({
	onMutate,
	onSettled,
}: UseGetRefundProvidersMutationProps) =>
	useMutation({
		mutationFn: (params: GetProfessionalParams) => getRefundProfessional(params),
		onMutate,
		onSettled,
	});
